import { lightImpactVibrate } from '../../../../utils/appBridge'
import { FILTER_OPTIONS } from '../../constants'
import { HarvestTypeFilter } from '../../types/withdrawals.types'

type WithdrawalsFilterChipsProps = {
  activeFilters: HarvestTypeFilter[]
  onToggleFilter: (value: HarvestTypeFilter) => void
}

export function WithdrawalsFilterChips({
  activeFilters,
  onToggleFilter,
}: WithdrawalsFilterChipsProps) {
  const handleClick = (value: HarvestTypeFilter) => {
    lightImpactVibrate?.()
    onToggleFilter(value)
  }

  return (
    <div
      role='tablist'
      aria-label='Filter withdrawals'
      className="shrink-0 flex gap-2 overflow-x-auto pb-1 pr-10 no-scrollbar"
    >
      {FILTER_OPTIONS.map((opt, index) => {
        const isSelected =
          opt.value === HarvestTypeFilter.ALL ? activeFilters.includes(HarvestTypeFilter.ALL) : activeFilters.includes(opt.value)
        return (
          <FilterChip
            key={opt.value}
            label={opt.label}
            value={opt.value}
            isSelected={isSelected}
            position={index + 1}
            setSize={FILTER_OPTIONS.length}
            onSelect={() => handleClick(opt.value)}
          />
        )
      })}
    </div>
  )
}

type FilterChipProps = {
  label: string
  value: HarvestTypeFilter
  isSelected: boolean
  position: number
  setSize: number
  onSelect: () => void
}

export function FilterChip({ label, value, isSelected, position, setSize, onSelect }: FilterChipProps) {
  return (
    <button
      type='button'
      role='tab'
      aria-selected={isSelected}
      aria-posinset={position}
      aria-setsize={setSize}
      aria-label={isSelected ? label : `${label}, double tap to select`}
      onClick={onSelect}
      style={{ width: label === 'All' ? '53px' : '73px' }}
      className={`
        shrink-0 flex items-center justify-center gap-2 rounded-[12px] 
        pb-[1px] h-[36px] text-[14px] font-[500] cursor-pointer px-4 bg-transparent
        ${isSelected
          ? 'border-[2px] border-[#3D3D3D] text-[#232323]'
          : 'border-[1.5px] border-[#F0F4F7] text-[#6A6E6E]'}
      `}
    >
      <span aria-hidden='true'>{label}</span>
    </button>
  )
}
